import { METRICS, type MetricType } from 'features/charts-v2/types'
import type { Breakdown } from 'features/charts-v2/types/filter-hash/v2'

const isSankeyCountMetric = (metric: MetricType): boolean =>
  metric === METRICS.RECORD_COUNT.id || metric === METRICS.SENTENCE_COUNT.id

/**
 * A Sankey artifact's wire rows carry `[count, avg]` — count first — but only
 * the count sizes a flow, so the metrics read off the wire are never the single
 * count the strategy needs as `selectedMetrics[0]` (the trailing sentiment
 * would become a metric tab or slice). Prefer the panel's own metric; fall back
 * to the count among the wire metrics. With neither, the wire metrics pass
 * through and the strategy reports the unsupported metric.
 */
export function resolveSankeyMetrics(
  panelMetrics: readonly MetricType[] | undefined,
  wireMetrics: MetricType[],
): MetricType[] {
  const count =
    panelMetrics?.find(isSankeyCountMetric) ??
    wireMetrics.find(isSankeyCountMetric)
  return count ? [count] : wireMetrics
}

/**
 * A grouped breakdown is queried as its leaf column, so `identifier.domains`
 * (what the artifact's breakdowns are normally read from) has lost the
 * `grouped` flag that makes it two flow columns. The panel the chart was drawn
 * from still has it, so prefer the panel's breakdowns when it carries any.
 */
export function resolveSankeyBreakdowns(
  panelBreakdowns: readonly Breakdown[] | undefined,
  domainBreakdowns: Breakdown[],
): Breakdown[] {
  return panelBreakdowns && panelBreakdowns.length > 0
    ? [...panelBreakdowns]
    : domainBreakdowns
}
